import React, { useEffect, useState } from 'react';
import { FuseNavigation, FuseUtils } from '@fuse';
import clsx from 'clsx';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { API_BASE_URL } from '@config';
import { getLmsConfig } from 'app/main/settings/store/actions/lms.actions';

const useStyles = makeStyles(()=> ({
	root: {
		'overflow-x': 'hidden'
	}
}));

const Navigation = props => {
	const navigation = useSelector(({ fuse }) => fuse.navigation);
	const user = useSelector(({ auth }) => auth.user);
	const lmsEnabled = useSelector(({ settings }) => !!(settings && settings.lms && settings.lms.config && settings.lms.config.enabled));
	const dispatch = useDispatch();
	const classes = useStyles();

	// "Heidi LMS" shows ONLY for organization admins AND only when this installation
	// has the LMS turned on (Settings > Configuration > Heidi LMS, default off).
	// Super-admins carry the 'admin' role too, so the role-based nav auth alone
	// cannot exclude them; we mirror the backend rule (organizationId + admin + NOT
	// super-admin) and additionally require the per-installation toggle.
	const roles = (user && Array.isArray(user.role)) ? user.role : [];
	const isOrgAdmin = !!(user && user.organizationId && roles.includes('admin') && !roles.includes('super-admin'));

	// Only org admins ever see the item, so only they need the (silent) status check.
	useEffect(() => {
		if (isOrgAdmin) dispatch(getLmsConfig());
	}, [dispatch, isOrgAdmin]);

	// "Heidi Documents" (Heidi Storage) shows wherever the feature is AVAILABLE for
	// the deployment (NODUS_FABRIC in /NODUS/.nodusrc) and a super-admin has
	// switched it ON (Settings > Storage). It shows even when the org has no
	// storage server yet, so admins DISCOVER the feature and land on the
	// upsell / deploy page (which explains entitlement + next steps). Silent check.
	const [storageOn, setStorageOn] = useState(false);
	useEffect(() => {
		let cancelled = false;
		axios
			.get(`${API_BASE_URL}/api/storage/feature`)
			.then((r) => { if (!cancelled) setStorageOn(!!(r.data && r.data.available && r.data.enabled)); })
			.catch(() => { if (!cancelled) setStorageOn(false); });
		return () => { cancelled = true; };
	}, [user && user.id]);

	let nav = navigation;
	if (!(isOrgAdmin && lmsEnabled)) nav = FuseUtils.removeNavItem(nav, 'heidi-lms');
	if (!storageOn) nav = FuseUtils.removeNavItem(nav, 'documents');

	return (
		<FuseNavigation
			className={clsx(classes.root, 'navigation', props.className)}
			navigation={nav}
			layout={props.layout}
			dense={props.dense}
		/>
	);
};

Navigation.defaultProps = {
	layout: 'vertical'
};

export default Navigation;
